export default __webpack_public_path__ + "static/media/random-person.f7754908.png";